import _ from 'lodash';

const REQUIRED_MESSAGE = "Required";
const EVEN_NUMBER_MESSAGE = "Need to be an even number";

export const REQUIRED = "REQUIRED";
export const EVEN_NUMBER = "EVEN_NUMBER";

const validationRules = {
  [REQUIRED]: (value)=> (value === undefined || String(value) === "") ?
    REQUIRED_MESSAGE : null,
  [EVEN_NUMBER]: (value) => parseInt(value, 10) % 2 === 0 ? null : EVEN_NUMBER_MESSAGE,
}

function validateAProp(value, rules =[], prop) {
  let errors = [];

  rules.forEach((rule)=> {
    let error = validationRules[rule](value);
    if (error) {
      if (prop) {
        error = `${prop} ${error}`;
      }
      errors.push(error);
    }
  });

  return errors;
}

export default function validate(value, rules = []) {
  let errors = [];

  if (typeof rules === 'object' && !Array.isArray(rules)) {
    for(const prop in rules) {
      let propErrors = validateAProp(
        value[prop],
        rules[prop],
        prop);
      errors = errors.concat(propErrors);
    }
  } else {
    errors = validateAProp(value, rules);
  }

  return errors;
}

export function validateAll(values, rules = {}){
  return _.chain(rules)
    .mapValues(o =>  o.validations)
    .reduce((result, validationRules, key)=>(
      _.concat(result, validate(values[key], validationRules))
    ), [])
    .value();
}




// WEBPACK FOOTER //
// ./src/lib/validation.js